module.exports = __webpack_public_path__ + "static/assets/f5649f11224bc0670b4596fea6478248.svg";